import api from "./api";

export const getMemberHistory = async (params) => {
  return api
    .get({
      endpoint: "/member/histories-by-owner",
      port: process.env.REACT_APP_PORT_VENUE,
      queryParam: params
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
